import * as RadixSwitch from "@radix-ui/react-switch"
import classNames from "classnames"
import React from "react"
import styled from "styled-components"
import { PrimitiveBaseProps, PrimitiveWithSizing } from "../helpers/types"
import { useSizing } from "../helpers/use-sizing"

interface Props
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    PrimitiveBaseProps<HTMLButtonElement>,
    PrimitiveWithSizing,
    React.ComponentProps<typeof RadixSwitch.Root> {}

const Root = styled(RadixSwitch.Root)`
  width: 42px;
  height: 24px;
  background: #c1c7cd; // gray30
  border-radius: 9999px;
  position: relative;
  --webkit-tap-highlight-color: "rgba(0, 0, 0, 0)";
  &[data-state="checked"] {
    background-color: ${(props) => props.theme.colors.primary || "black"};
  }
`

const Thumb = styled(RadixSwitch.Thumb)`
  display: block;
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 9999px;
  transition: transform 100ms;
  transform: translateX(5px);
  will-change: transform;
  &[data-state="checked"] {
    transform: translateX(21px);
  }
`

export function Toggle(props: Props) {
  const {
    innerRef,
    className,
    "data-node-id": dataNodeId,
    mainAxisSizing = "hug",
    crossAxisSizing = "hug",
    ...otherProps
  } = props

  const sizingClassName = useSizing(mainAxisSizing, crossAxisSizing)

  return (
    <Root ref={innerRef} className={classNames(className, sizingClassName)} data-node-id={dataNodeId} {...otherProps}>
      <Thumb />
    </Root>
  )
}
